import {
  PayByLinkConfigurationDTO,
  PayByLinkProcessRequestDTO,
  PayByLinkTransactionResponseDTO,
  BrowserDataDTO,
} from 'src/services/api/data-contracts';
import { CreditCard } from 'src/types/common';

export interface IPayByLinkSessionState {
  PropertyId: number;
  transaction: PayByLinkTransaction;
  PageUrl: string;
}

export enum PayByLinkType {
  Reservation = 'Reservation',
  ReservationItem = 'ReservationItem',
  HouseAccount = 'HouseAccount',
  ShopOrder = 'ShopOrder',
  Event = 'Event',
}

export enum PayByLinkAction {
  None = 'None',
  Pay = 'Pay',
  StoreCard = 'StoreCard',
}

export class PayByLinkTransaction {
  constructor(
    propertyId: number,
    data: PayByLinkTransactionResponseDTO,
    config: PayByLinkConfigurationDTO,
  ) {
    this.Config = config;

    this.PropertyId = propertyId;
    this.CreditCard = new CreditCard();

    if (data != null) {
      this.EntityId = data.EntityId;
      this.Type = data.Type as PayByLinkType;
      this.Action = data.Action as PayByLinkAction;
      this.Timestamp = data.Timestamp;
      this.InvoiceNumber = data.InvoiceNumber;
      this.Description = data.Description;
      this.AmountToPay = data.AmountToPay;
      this.PaymentId = data.PaymentId;
      this.Hash = data.Hash;
    }
  }

  Config: PayByLinkConfigurationDTO;

  PropertyId: number;
  EntityId: number;
  Type: PayByLinkType;
  Action: PayByLinkAction;
  Timestamp: number;
  InvoiceNumber: string;
  Description: string;
  AmountToPay: number;
  PaymentId: string;
  Hash: string;

  CreditCard: CreditCard;

  toDTO(): PayByLinkProcessRequestDTO {
    return {
      PropertyId: this.PropertyId,
      Type: this.Type,
      Action: this.Action,
      InvoiceNumber: this.InvoiceNumber,
      EntityId: this.EntityId,
      AmountToPay: this.AmountToPay,
      PaymentId: this.PaymentId,
      Hash: this.Hash,
      Timestamp: this.Timestamp,
      Email: this.CreditCard.cardHolderEmail,
      CardDetails: this.CreditCard.toDTO(),
      BrowserData: {
        ColorDepthInBits: screen.colorDepth,
        JavaScriptEnabled: true,
        BrowserLanguage: navigator.language,
        ScreenHeight: screen.height,
        ScreenWidth: screen.width,
        UserAgent: navigator.userAgent,
        TimezoneOffSet: new Date().getTimezoneOffset().toString(),
      } as BrowserDataDTO,
    };
  }
}
